import $ from "jquery";
/*
    Helper is for elements fixed to the bottom on mobile Safari, when the user has the app downloaded
    and the apple universial link banner appears when scrolled all the way to the top of the page.
*/

const AppleBannerHelpers = {
  appleBannerHeight: function () {
    const defaultHeight = 0;

    if (typeof window === "undefined" || typeof $ === "undefined") {
      return defaultHeight;
    }

    return Math.max($(window).innerHeight() - window.innerHeight, defaultHeight);
  },
};

export default AppleBannerHelpers;

export const { appleBannerHeight } = AppleBannerHelpers;
